import { useProfileQueryContext } from './contexts';
import { InsightTable } from './InsightTable';
import { useTranslation } from '../hooks';

export const DevicesTable = () => {
  const { t } = useTranslation();
  const { devices } = useProfileQueryContext();
  const title = t('insights.devices');
  const values = devices ?? [];

  return <InsightTable title={title} values={values} isEnabled={!!values.length} showDivider />;
};
